
export const supportFilterData = {
    loginId:"",
    date:""
}

interface FilterCheck {
    check:boolean,
    value:string
}

export interface InformationDataValidationSupportProps{
    description: string,
    cardName: string,
    api: string,
    filters: any,
    filtersCheck: FilterCheck
}

export const dummyData = [
    {
        "id": "1", 
        "Book Name": "Computer Architecture",
        "Category": "Computers",
        "Price": "125.60"
    },
    {
        "id": "2",
        "Book Name": "Asp.Net 4 Blue Book",
        "Category": "Programming",
        "Price": "56.00"
    },
    {
        "id": "3",
        "Book Name": "Popular Science",
        "Category": "Science",
        "Price": "210.40"
    }
]